import { useState, useEffect, createContext } from "react";
import { useRouter } from "next/router";
import useMobileDetect from "helpers/useMobileDetect";

export interface ClevertapBannerContextProps {
  detectClevertapBanner: boolean;
}
export const ClevertapBannerContext = createContext<ClevertapBannerContextProps>(
  {
    detectClevertapBanner: false,
  }
);

export const ClevertapBannerProvider: React.FC = (props) => {
  const currentDevice = useMobileDetect();
  const [detectClevertapBanner, setDetectClevertapBanner] = useState<boolean>(
    false
  );

  useEffect(() => {
    currentDevice.isMobile() &&
      setTimeout(() => {
        detectBanner();
      }, 2000);
  }, [useRouter().pathname]);

  const detectBanner = () => {
    const clevertapBannerwizParDiv2 = document.getElementById("wizParDiv2");
    clevertapBannerwizParDiv2
      ? (setDetectClevertapBanner(true), shiftDomDown(), addRemoveBtn())
      : (setDetectClevertapBanner(false), shiftDomUp());
  };

  const shiftDomDown = () => {
    const fixedHeader = document.getElementById("fixedHeaderCT");
    const fixedSpecialityHeader = document.getElementById(
      "fixedSpecialityHeaderCT"
    );
    const fixedSearch = document.getElementById("fixedSearchCT");
    const mainContainer = document.getElementById("mainContainerCT");
    if (fixedHeader !== null && mainContainer !== null) {
      fixedHeader.style.top = "60px";
      mainContainer.style.marginTop = "60px";
    }
    fixedSearch && (fixedSearch.style.top = "132px");
    fixedSpecialityHeader && (fixedSpecialityHeader.style.top = "60px");
  };

  const shiftDomUp = () => {
    const fixedHeader = document.getElementById("fixedHeaderCT");
    const fixedSpecialityHeader = document.getElementById(
      "fixedSpecialityHeaderCT"
    );
    const fixedSearch = document.getElementById("fixedSearchCT");
    const mainContainer = document.getElementById("mainContainerCT");
    if (fixedHeader !== null && mainContainer !== null) {
      fixedHeader.style.top = "0px";
      mainContainer.style.marginTop = "0px";
    }
    fixedSearch && (fixedSearch.style.top = "70px");
    fixedSpecialityHeader && (fixedSpecialityHeader.style.top = "0px");
  };

  const addRemoveBtn = () => {
    const button = document.createElement("button");
    button.className = "clevertapCloseBtn";
    button.onclick = removeBanner;
    document.body.appendChild(button);
  };

  const removeBanner = () => {
    const clevertapBannerwizParDiv2 = document.getElementById("wizParDiv2");
    clevertapBannerwizParDiv2.remove();
    shiftDomUp();
  };

  return (
    <ClevertapBannerContext.Provider value={{ detectClevertapBanner }}>
      {props.children}
    </ClevertapBannerContext.Provider>
  );
};
